<template>
  <!-- eslint-disable -->
  <div class="vip_wrap is_login">
    <div class="vip_area account_area">
      <div class="account_wrap d-grid" :style="'background-image: url(' + imgVipBg + ')'">
        <div class="vip_inner_top d-grid">
          <div class="vip_privilege d-flex flex-column align-items-center justify-content-end">
            <VueSlickCarousel ref="c1" v-bind="slick_setting" :class="'slider-products vip_privilege_card d-grid mb-0'"
              @afterChange="changeCarousel">
              <!-- <span v-for="(vip, key) in allVipInfo" :id="'slider-span-'+key" :key="key" v-b-popover.bottom.html="getVBPopoverOptions(vip)" @focus="showPopover(key)" @focusout="closePopover(key)"> -->
              <span v-for="(vip, key) in allVipInfo" :id="'slider-span-' + key" :key="key">
                <button class="d-block position-relative border-0 bg-transparent">
                  <img class="mw-100" :src="vip.image_big" alt="">
                </button>
              </span>
              <template #prevArrow="arrowOption">
                <button />
              </template>
              <template #nextArrow="arrowOption">
                <button />
              </template>
            </VueSlickCarousel>
            <div class="position-relative">
              <VueSlickCarousel ref="c2" v-bind="slick_dot_setting"
                :class="'slider-nav vip_privilege_title d-grid mb-0'">
                <div v-for="(vip, key) in allVipInfo" :key="key"
                  class="vip_privilege_info d-flex flex-column align-items-center">
                  <small class="privilege_dots" />
                  <p class="vip_privilege_lv mb-0">
                    {{ vip.note }}
                  </p>
                </div>
              </VueSlickCarousel>
              <div class="vip_privilege_line position-absolute mb-0" />
            </div>
          </div>
          <div class="vip_offer">
            <div class="vip_offer_title d-flex align-items-center justify-content-center">
              <span v-show="all_spec_icon_show" class="vip_privilege_diamond" />
              <h6 v-show="all_spec_icon_show" class="mb-0">
                {{ $t("Bao.member_benefits") }}
              </h6>
              <span v-show="all_spec_icon_show" class="vip_privilege_diamond" />
            </div>
            <ul class="vip_offer_list d-grid align-items-center justify-content-center list-unstyled">
              <li v-show="spec_icon_show.upgrade_money">
                <div class="vip_offer_items d-grid">
                  <img :src="imgVipOffer[0]" alt="" style="width: 100px; height: 100px">
                  <h5 class="text-center mb-0">
                    {{ selectedVip.upgrade_prize }}
                  </h5>
                </div>
              </li>

              <li v-show="spec_icon_show.monthly_prize">
                <div class="vip_offer_items d-grid">
                  <img :src="imgVipOffer[1]" alt="" style="width: 100px; height: 100px">
                  <h5 class="text-center mb-0">
                    {{ selectedVip.monthly_prize }}
                  </h5>
                </div>
              </li>

              <li v-show="spec_icon_show.birthday_prize">
                <div class="vip_offer_items d-grid">
                  <img :src="imgVipOffer[2]" alt="" style="width: 100px; height: 100px">
                  <h5 class="text-center mb-0">
                    {{ selectedVip.birthday_prize }}
                  </h5>
                </div>
              </li>

              <li v-show="spec_icon_show.roll_money">
                <div class="vip_offer_items d-grid">
                  <img :src="imgVipOffer[3]" alt="" style="width: 100px; height: 100px">
                  <h5 class="text-center mb-0">
                    {{ currentVipNote }}
                  </h5>
                </div>
              </li>

              <li v-show="spec_icon_show.points_mall">
                <div class="vip_offer_items d-grid">
                  <img :src="imgVipOffer[4]" alt="" style="width: 100px; height: 100px">
                  <h5 class="text-center mb-0">
                    {{ $t("Bao.points_mall") }}
                  </h5>
                </div>
              </li>

              <li v-show="spec_icon_show.vip_service">
                <div class="vip_offer_items d-grid">
                  <img :src="imgVipOffer[5]" alt="" style="width: 100px; height: 100px">
                  <h5 class="text-center mb-0">
                    {{ $t("Bao.cs_24") }}
                  </h5>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="vip_inner_middle">
          <div class="vip_table_same">
            <ul id="myTab" class="vip_inner_bar nav nav-tabs border-0" role="tablist">
              <li class="nav-item" role="presentation">
                <a id="home-tab" :class="[vip_tab_class, { active: vipLevelShow }]"
                  @click="vipLevelShow = true">{{ $t("Bao.vip_benefit_table") }}</a>
              </li>
              <li v-if="$store.getters.webInfo.show_vip_rebate === 1" class="nav-item" role="presentation" @click="vipLevelShow = false">
                <a id="profile-tab" class="btn btn_vip right" :class="{ active: !vipLevelShow }"
                  @click="vipLevelShow = false">{{ $t("Bao.vip_rebate_table") }}</a>
              </li>
            </ul>
            <div id="myTabContent" class="tab-content">
              <div id="home" class="tab-pane fade" :class="{ show: vipLevelShow, active: vipLevelShow }" role="tabpanel"
                aria-labelledby="home-tab">
                <div class="table_scroll overflow-auto">
                  <div class="table_middle list-unstyled mb-0">
                    <ul class="table_middle_data text-center list-unstyled mb-0">
                      <li>{{ $t("Bao.level") }} </li>
                      <!--                      <li>{{ $t("Bao.vip_upgrade_award") }}<br/>&nbsp;</li>-->
                      <li v-html="this.checkBreak($t('Bao.vip_upgrade_award'))" />
                      <li v-html="this.checkBreak($t('Bao.birthday_prize'))" />
                      <li v-html="this.checkBreak($t('Bao.payment_withdrawal_limit'))" />
                      <li v-html="this.checkBreak($t('Bao.free_withdrawal_times'))" />
                      <li v-if="$store.getters.permissionInfo.enable_roll === 1"
                        v-html="this.checkBreak($t('Bao.roll_prize'))" />
                      <li v-html="this.checkBreak($t('Bao.monthly_prize'))" />
                      <li v-html="this.checkBreak($t('Bao.upgrade_deposit'))" />
                      <li v-html="this.checkBreak($t('Bao.upgrade_bet_amount'))" />
                      <li v-html="this.checkBreak($t('Bao.keep_bet_amount'))" />
                      <li v-html="this.checkBreak($t('Bao.keep_deposit'))" />
                    </ul>
                    <ul v-for="(vip, key) in allVipInfo" :key="key" :class="{ active: isCurrentVipLevel(vip) }"
                      class="table_middle_data text-center list-unstyled mb-0">
                      <li>{{ vip.level_name }}</li>
                      <li v-if="vip.upgrade_prize_text_enable === 1">{{ vip.upgrade_prize_text }}</li>
                      <li v-else>{{ vip.upgrade_prize | commaVal(lang, ten_thousand) }}</li>
                      <li v-if="vip.birthday_prize_text_enable === 1">{{ vip.birthday_prize_text }}</li>
                      <li v-else>{{ vip.birthday_prize | commaVal(lang, ten_thousand) }}</li>
                      <li v-if="vip.limit_withdrawal_text_enable === 1">{{ vip.limit_withdrawal_text }}</li>
                      <li v-else>{{ vip.limit_withdrawal | commaVal(lang, ten_thousand) }}</li>
                      <li v-if="vip.free_withdrawal_times_text_enable === 1">{{ vip.free_withdrawal_times_text }}</li>
                      <li v-else>{{ vip.free_withdrawal_times | commaVal(lang, ten_thousand) }}</li>
                      <li v-if="vip.spec_icon_roll_text_enable === 1">{{ vip.spec_icon_roll_text }}</li>
                      <li v-else-if="$store.getters.permissionInfo.enable_roll === 1">{{ checkRollRoom(vip.spec_icon_show) }}</li>
                      <li v-if="vip.monthly_prize_text_enable === 1">{{ vip.monthly_prize_text }}</li>
                      <li v-else>{{ vip.monthly_prize | commaVal(lang, ten_thousand) }}</li>
                      <li v-if="vip.upgrade_deposit_text_enable === 1">{{ vip.upgrade_deposit_text }}</li>
                      <li v-else>{{ vip.upgrade_deposit | commaVal(lang, ten_thousand) }}</li>
                      <li v-if="vip.upgrade_bet_amount_text_enable === 1">{{ vip.upgrade_bet_amount_text }}</li>
                      <li v-else>{{ vip.upgrade_bet_amount | commaVal(lang, ten_thousand) }}</li>
                      <li v-if="vip.keep_bet_amount_text_enable === 1">{{ vip.keep_bet_amount_text }}</li>
                      <li v-else>{{ vip.keep_bet_amount | commaVal(lang, ten_thousand) }}</li>
                      <li v-if="vip.keep_deposit_text_enable === 1">{{ vip.keep_deposit_text }}</li>
                      <li v-else>{{ vip.keep_deposit | commaVal(lang, ten_thousand) }}</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div id="profile" class="tab-pane fade" :class="{ show: !vipLevelShow, active: !vipLevelShow }"
                role="tabpanel" aria-labelledby="profile-tab">
                <div class="table_scroll overflow-auto">
                  <div class="table_middle list-unstyled mb-0">
                    <ul v-for="(rebate, key) in rebateInfo" :key="key"
                      :class="{ active: isCurrentVipLevelByName(rebate[0]) }"
                      class="table_middle_data text-center list-unstyled mb-0 ">
                      <li v-for="(vendor, sub_key) in rebate" :key="sub_key">
                        {{ vendor }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <component :is="currentRule" />
      </div>
    </div>
  </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import { getImage } from '@/api/brand'
import { getAllVipInfo, getRebateInfo } from '@/api/vip'
import { showNotice } from '@/utils/tool'
import { VBPopover } from 'bootstrap-vue'

export default {
  directives: {
    'b-popover': VBPopover
  },
  components: { VueSlickCarousel },
  filters: {
    commaVal: function(value, lang, tenThousand) {
      if (lang === 'vn' || lang === 'en') {
        if (isNaN(value)) return value
        if (value > 0) {
          value = String(value * 1000)
        } else {
          value = String(value)
        }

        if (value.length < 4) return value
        else if (value.length >= 4 && value.length < 7) {
          return value.slice(0, -3) + 'K'
        } else if (value.length >= 7 && value.length < 10) {
          return value.slice(0, -6) + 'M'
        } else {
          return value.slice(0, -9) + 'B'
        }
      } else {
        if (isNaN(value)) return value
        value = String(value)
        if (value.length < 5) return value

        return value.slice(0, -4) + tenThousand
      }
    }
  },
  data() {
    return {
      lang: this.$store.getters.language,
      ten_thousand: this.$t('Bao.ten_thousand'),
      thousand: this.$t('Bao.thousand'),
      million: this.$t('Bao.million'),
      allVipInfo: [
        {
          lavel_name: 'lv1',
          image_big: '',
          note: 'lv1'
        },
        {
          lavel_name: 'lv2',
          image_big: '',
          note: 'lv2'
        },
        {
          lavel_name: 'lv3',
          image_big: '',
          note: 'lv3'
        },
        {
          lavel_name: 'lv4',
          image_big: '',
          note: 'lv4'
        }
      ],
      rebateInfo: [],
      vipLevelShow: true,
      currentVipLevel: 1,
      currentVipNote: '',
      selectedVip: {
        key: 0,
        upgrade_prize: 0,
        monthly_prize: 0,
        birthday_prize: 0
      },
      spec_icon_show: {
        upgrade_money: true,
        monthly_prize: true,
        birthday_prize: true,
        roll_money: true,
        points_mall: true,
        vip_service: true
      },
      all_spec_icon_show: true,
      slick_setting: {
        dots: false,
        centerMode: true,
        centerPadding: '0px',
        infinite: true,
        slidesToShow: 3,
        draggable: true,
        initialSlide: 0,
        focusOnSelect: true,
        asNavFor: {},
        lazyLoad: 'ondemand',
        responsive: [
          {
            breakpoint: 1199,
            settings: {
              centerPadding: '10px',
              slidesToShow: 1,
              slidesToScroll: 3,
              infinite: false,
              dots: false,
              variableWidth: true
            }
          }
        ]
      },
      slick_dot_setting: {
        dots: false,
        centerMode: true,
        centerPadding: '10px',
        infinite: true,
        slidesToShow: 3,
        draggable: false,
        initialSlide: 0,
        arrows: false,
        responsive: [
          {
            breakpoint: 1199,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 3,
              infinite: false,
              dots: false
            }
          }
        ]
      },
      vipInfo: {},
      imgVipBg: '',
      imgVipOffer: []
    }
  },
  computed: {
    currentRule() {
      const brand = 'default'
      // if (this.$store.getters.brand.currency === 'PHP') {
      //   brand = 'php'
      // }
      let name = brand + '_' + this.lang
      // 語系為 php 時顯示 en
      if (this.lang === 'ph') {
        name = brand + '_en'
      }
      return () => import('@/views/vip/rules/' + name + '.vue')
    },
    vip_tab_class() {
      return (this.$store.getters.webInfo.show_vip_rebate) ? 'btn btn_vip left' : 'btn btn_vip'
    }
  },
  created() {
    if (this.$store.state.user.vipInfo) {
      this.vipInfo = this.$store.state.user.vipInfo
    }

    getImage({
      'group_code': 'login_banner'
    }).then(response => {
      this.img = response.data.data[0].image
    }).catch((error) => {
      console.log(error)
    })

    getImage({
      'group_code': 'vip_banner'
    }).then(response => {
      this.imgVipBg = response.data.data[0].image
    }).catch((error) => {
      console.log(error)
    })

    getImage({
      'group_code': 'vip_spec_icon_show'
    }).then(response => {
      for (const obj of response.data.data) {
        this.imgVipOffer.push(obj.image)
      }
    }).catch((error) => {
      console.log(error)
    })
  },
  mounted() {
    // console.log(this.$store.getters.permissionInfo.enable_roll)
    // console.log(this.lang)
    // console.log(this.$store.getters.brand.currency)

    // 必須在此設定 refs才有值
    this.slick_setting.asNavFor = this.$refs.c2
    getAllVipInfo()
      .then((response) => {
        this.allVipInfo = response.data.data
        if (!this.$store.state.user.vipInfo) {
          this.vipInfo = {
            currentVipName: this.allVipInfo[0].level_name
          }
        }
        this.$root.$emit('bv::disable::popover')
        this.setCurrentVipLevel()
        this.slick_setting.initialSlide = this.currentVipLevel - 1
        this.slick_dot_setting.initialSlide = this.currentVipLevel - 1
      })
      .catch((error) => {
        showNotice(error.response.data.msg)
      })
    getRebateInfo({ reverse_data: false })
      .then((response) => {
        this.rebateInfo = response.data.data
      })
      .catch((error) => {
        showNotice(error.response.data.msg)
      })
  },
  methods: {
    checkBreak(text) {
      if (text.indexOf('<br/>') >= 0) {
        return text
      } else {
        // return text + '<br/>&nbsp'
        return text
      }
    },
    setCurrentVipLevel() {
      for (const i in this.allVipInfo) {
        if (this.vipInfo.currentVipName === this.allVipInfo[i].level_name) {
          this.$root.$emit('bv::enable::popover', 'slider-span-' + i)
          this.currentVipLevel = this.allVipInfo[i].level
          this.currentVipNote = this.allVipInfo[i].note
          this.selectedVip = {
            key: i,
            upgrade_prize: this.allVipInfo[i].upgrade_prize,
            monthly_prize: this.allVipInfo[i].monthly_prize,
            birthday_prize: this.allVipInfo[i].birthday_prize
          }
          this.setCurrentVipSpecIcon(this.allVipInfo[i].spec_icon_show)
        }
      }
    },
    isCurrentVipLevel(vip) {
      if (vip.level === this.currentVipLevel) return true
      else return false
    },
    isCurrentVipLevelByName(vipName) {
      if (vipName === this.vipInfo.currentVipName) return true
      else return false
    },
    vip_exclusive_offer_page() {
      if (this.$router.currentRoute.path.indexOf('/web') >= 0) {
        this.$router.push('/web/page/vip')
      } else {
        this.$router.push('/page/vip')
      }
    },
    changeCarousel(index) {
      this.selectedVip = {
        key: index,
        upgrade_prize: this.allVipInfo[index].upgrade_prize,
        monthly_prize: this.allVipInfo[index].monthly_prize,
        birthday_prize: this.allVipInfo[index].birthday_prize
      }
      this.currentVipNote = this.allVipInfo[index].note
      this.setCurrentVipSpecIcon(this.allVipInfo[index].spec_icon_show)
      this.$root.$emit('bv::disable::popover')
      this.$root.$emit('bv::enable::popover', 'slider-span-' + index)
    },
    getVBPopoverOptions(vip) {
      return {
        content: `
          <div class="vip_privilege_hover p-10">
            <img class="mw-100" src="` + vip.image_banner + `" alt="">
          </div>
        `,
        html: true,
        fallbackPlacement: ['buttom', 'buttom', 'buttom', 'buttom']
      }
    },
    setCurrentVipSpecIcon(select_spec_icon_show) {
      if (select_spec_icon_show) {
        this.all_spec_icon_show = true
        this.spec_icon_show.upgrade_money = (select_spec_icon_show.indexOf('upgrade_money') > -1)
        this.spec_icon_show.monthly_prize = (select_spec_icon_show.indexOf('monthly_prize') > -1)
        this.spec_icon_show.birthday_prize = (select_spec_icon_show.indexOf('birthday_prize') > -1)
        this.spec_icon_show.roll_money = (select_spec_icon_show.indexOf('roll_money') > -1)
        this.spec_icon_show.points_mall = (select_spec_icon_show.indexOf('points_mall') > -1)
        this.spec_icon_show.vip_service = (select_spec_icon_show.indexOf('vip_service') > -1)
      } else {
        this.all_spec_icon_show = false
        this.spec_icon_show = {
          upgrade_money: false,
          monthly_prize: false,
          birthday_prize: false,
          roll_money: false,
          points_mall: false,
          vip_service: false
        }
      }
    },
    checkRollRoom(spec_icon_show) {
      if (spec_icon_show) {
        return (spec_icon_show.indexOf('roll_money') > 0) ? '√' : '-'
      } else {
        return '-'
      }
    },
    showPopover(key) {
      if (this.selectedVip.key !== key) return
      this.$root.$emit('bv::enable::popover', 'slider-span-' + key)
    },
    closePopover(key) {
      this.$root.$emit('bv::hide::popover', 'slider-span-' + key)
    }
  }
}
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity .15s
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active in <2.1.8 */
  {
  opacity: 0
}

.vip_wrap .vip_area .vip_inner_top div.slick-slider {
  display: grid;
}

.vip_wrap .vip_area .vip_inner_top button.slick-prev {
  left: 0;
}

.vip_wrap .vip_area .vip_inner_top button.slick-next {
  right: 0;
}

@media only screen and (min-width: 1765px) {
  .index_block_area .main_area .main_inner .main_wrap {
    grid-template-columns: 865px 240px;
  }
}

span:focus {
  outline: none;
}

.vip_wrap .vip_area .vip_inner_top .vip_privilege_card .slick-track {
  margin-bottom: 10px;
}

.vip_wrap .vip_area .vip_inner_middle .table_middle .table_middle_data.active>li {
  border-bottom: 1px #383940 solid;
}

.vip_wrap .vip_area .vip_inner_middle .table_middle .table_middle_data.active>li:last-child {
  border-bottom: none;
}

@media only screen and (max-width: 1199px) {
  .vip_wrap .vip_area .vip_inner_top .vip_privilege_card .slick-arrow {
    display: none;
  }

  .custom_vip_wrap .main_inner {
    margin: 0;
  }

  .vip_wrap .vip_area .vip_inner_middle .table_middle .rebate_table_row {
    width: 3200px;
  }

  .slider-products .slick-slide {
    width: 280px;
  }

  .vip_wrap .vip_area .vip_inner_top .vip_privilege_card .slick-slide.slick-current.slick-center button,
  .vip_wrap .vip_area .vip_inner_top .vip_privilege_card .slick-slide.slick-active button {
    -webkit-transform: scale(1) translateZ(0);
    transform: scale(1) translateZ(0);
  }

  .vip_wrap .vip_area .vip_inner_top .vip_privilege_card .slick-track {
    padding: 30px 0;
  }

  .vip_wrap.is_login .vip_inner_top {
    grid-template-rows: 340px 1fr;
  }

  .vip_wrap .vip_area .vip_inner_middle .table_middle .table_middle_data.active>li {
    border-right: 1px #383940 solid;
  }
}

.vip_wrap .vip_area .vip_inner_middle .vip_table_same .vip_inner_bar>li .btn_vip.left {
}
.vip_wrap .vip_area .vip_inner_middle .vip_table_same .vip_inner_bar>li .btn_vip {
  border: 1px solid #82848b;
  padding: 7px 46px;
}
</style>
